module.exports = __webpack_public_path__ + "img/reject.2cdefb3a.svg";